<app-page-heading [key]="'local-loads.manual.form.page-title'"
                  [carriers]="carriers" [(selectedCarrier)]="selectedCarrier" (selectedCarrierChange)="carrierChanged()">
</app-page-heading>

<section class="container">
    <div class="row">
        <div class="col-xs-12">
            <div class="row">
                <div class="col-xs-8">
                    <button type="button" class="btn btn-primary btn-outline btn-lg pull-left" (click)="location.back()">
                        <span class="fa fa-arrow-left"> </span>
                    </button>
                </div>
            </div>

            <br>

            <div class="ibox float-e-margins">
                <div class="ibox-content border-primary">

                    <form #localLoadForm="ngForm" novalidate class="row" (keyup.control.enter)="processForm()">
                        <fieldset [disabled]="formProcessingBlocked" class="col-xs-12">

                            <div class="form-group">
                                <label class="control-label" for="load-id" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.load-id.label'}]"></label>
                                <input class="form-control input-lg" name="load-id" id="load-id" type="text"
                                       [(ngModel)]="request.loadId" required>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.load-id.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <label class="control-label" for="vehicle" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.vehicle.label'}]"></label>
                                <input class="form-control input-lg" name="vehicle" id="vehicle" type="text" appAutofocus
                                       [(ngModel)]="request.vehicle" required>
                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.vehicle.help'}]"></small>
                            </div>

                            <div class="form-group">
                                <button type="button" class="btn btn-primary" (click)="openAddShipment(addShipmentModal)" #addShipmentBtn>Add Shipment</button>
                                <button type="button" class="btn btn-primary m-l-md" (click)="openAddLocation(addLocationModal)" *ngIf="authService.canManageLocations()">Add Location</button>
                            </div>

                            <div class="form-group">

                                <div *ngFor="let stop of request.stops; let stopIndex = index" class="m-l-lg">
                                    <hr *ngIf="stopIndex > 0">

                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.stop-type.label'}]"></label>
                                                <input class="form-control input-lg" [name]="'stop-type-' + stopIndex" type="text"
                                                       [ngModel]="stop.type" readonly>
                                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.stop-type.help'}]"></small>
                                            </div>
                                        </div>
                                        <div class="col-md-8">
                                            <div class="form-group">
                                                <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.stop-location.label'}]"></label>
                                                <input class="form-control input-lg" [name]="'stop-location-' + stopIndex" type="text"
                                                       [ngModel]="stop.location.reference + ' - ' + stop.location.name" readonly>
                                                <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.stop-location.help'}]"></small>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="m-l-lg">
                                        <div class="form-group" *ngFor="let shipment of stop.shipments; let shipmentIndex = index">
                                            <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.delivery-number.label'}]"></label>
                                            <input class="form-control input-lg" [name]="'delivery-number-' + stopIndex + '-' + shipmentIndex" type="text"
                                                   [ngModel]="shipment.deliveryNumber" readonly>
                                            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.delivery-number.help'}]"></small>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <input type="hidden" name="local-load-stops" [ngModel]="request.stops[0]" required>
                            <input type="hidden" name="local-load-carrier" [ngModel]="selectedCarrier?.id" required>

                            <div class="form-buttons pull-right">
                                <button type="button" class="btn btn-primary btn-lg" (click)="processForm()"
                                        [disabled]="localLoadForm.invalid">
                                    <span class="fa fa-save space-right-5"></span>
                                    <span [i18n]="[{target: 'innerHTML', key: 'buttons.save'}]"></span>
                                </button>
                            </div>

                        </fieldset>
                    </form>
                </div>
            </div>
        </div>
    </div>
</section>


<ng-template #addShipmentModal>
    <form #addShipmentForm="ngForm" novalidate class="row" (keyup.control.enter)="validateAddShipmentModal()">
        <div class="form-group">
            <label class="control-label" for="delivery-number" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.delivery-number.label'}]"></label>
            <input class="form-control input-lg" name="delivery-number" id="delivery-number" type="text"
                   [(ngModel)]="newShipment.deliveryNumber" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.delivery-number.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="delivery-number" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.sales-order-number.label'}]"></label>
            <input class="form-control input-lg" name="sales-order-number" id="sales-order-number" type="text"
                   [(ngModel)]="newShipment.salesOrderNumber" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.sales-order.help'}]"></small>
        </div>

        <div class="form-group">
            <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-shipment.pick.label'}]"></label>

            <div class="row">
                <div class="col-md-6">
                    <div class="input-group input-group-lg">
                        <input class="form-control input-lg" name="location-pick-location-search" type="text" appAutofocus
                               [(ngModel)]="newShipment.pickLocationSearchString" (keyup.enter)="searchPickLocation(newShipment)" required>
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-primary" (click)="searchPickLocation(newShipment)">
                                <i class="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <select class="form-control input-lg" name="location-pick-location" id="location-pick-location" required
                            [(ngModel)]="newShipment.pickLocation">
                        <option *ngFor="let location of newShipment.pickLocationSearchResult" [ngValue]="location">
                            {{ location.reference + ' - ' + location.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-shipment.drop.label'}]"></label>

            <div class="row">
                <div class="col-md-6">
                    <div class="input-group input-group-lg">
                        <input class="form-control input-lg" name="location-drop-location-search" type="text" #addShipmentSearchDropInput
                               [(ngModel)]="newShipment.dropLocationSearchString" (keyup.enter)="searchDropLocation(newShipment)" required>
                        <span class="input-group-btn">
                            <button type="button" class="btn btn-primary" (click)="searchDropLocation(newShipment)">
                                <i class="fa fa-search"></i>
                            </button>
                        </span>
                    </div>
                </div>
                <div class="col-md-6">
                    <select class="form-control input-lg" name="location-drop-location" id="location-drop-location" required
                            [(ngModel)]="newShipment.dropLocation">
                        <option *ngFor="let location of newShipment.dropLocationSearchResult" [ngValue]="location">
                            {{ location.reference + ' - ' + location.name }}
                        </option>
                    </select>
                </div>
            </div>
        </div>

        <div class="form-group">
            <label class="control-label" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.items.label'}]"></label>
            <button type="button" class="btn btn-primary pull-right" (click)="addItem()">Add Item</button>

            <div class="m-l-lg" *ngFor="let item of newShipment.items; let i = index">
                <hr *ngIf="i > 0">
                <div class="form-group">
                    <label class="control-label" for="line" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.line.label'}]"></label>
                    <input class="form-control input-lg" [name]="'line-' + i" id="line" type="text"
                           [ngModel]="(i + 1) * 10" readonly>
                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.line.help'}]"></small>
                </div>
                <div class="form-group">
                    <label class="control-label" for="quantity" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.quantity.label'}]"></label>
                    <input class="form-control input-lg" [name]="'quantity' + i" id="quantity" type="text"
                           [(ngModel)]="item.quantity" required>
                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.quantity.help'}]"></small>
                </div>
                <div class="form-group">
                    <label class="control-label" for="product-code" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.product-code.label'}]"></label>
                    <input class="form-control input-lg" [name]="'product-code' + i" id="product-code" type="text"
                           [(ngModel)]="item.productCode" required>
                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.product-code.help'}]"></small>
                </div>
                <div class="form-group m-b-lg">
                    <label class="control-label" for="product-description" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.product-description.label'}]"></label>
                    <input class="form-control input-lg" [name]="'product-description' + i" id="product-description" type="text"
                           [(ngModel)]="item.productDescription" required>
                    <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.product-description.help'}]"></small>
                </div>
            </div>
        </div>
    </form>
</ng-template>


<ng-template #addLocationModal>
    <form #addLocationForm="ngForm" novalidate class="row">
        <div class="form-group">
            <label class="control-label" for="name" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.name.label'}]"></label>
            <input class="form-control input-lg" name="name" id="name" type="text"
                   [(ngModel)]="newLocation.name" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.name.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="glid" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.glid.label'}]"></label>
            <input class="form-control input-lg" name="glid" id="glid" type="text"
                   [(ngModel)]="newLocation.glid" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.glid.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="location-type" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.location-type.label'}]"></label>
            <select class="form-control input-lg m-b" name="location-type" id="location-type" required
                    [(ngModel)]="newLocation.type">
                <option [value]="'CHEP'">CHEP</option>
                <option [value]="'CUST'">CUST</option>
            </select>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.location-type.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="address1" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.address1.label'}]"></label>
            <input class="form-control input-lg" name="address1" id="address1" type="text"
                   [(ngModel)]="newLocation.address.address1" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.address1.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="city" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.city.label'}]"></label>
            <input class="form-control input-lg" name="city" id="city" type="text"
                   [(ngModel)]="newLocation.address.city" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.city.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="zip" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.zip.label'}]"></label>
            <input class="form-control input-lg" name="zip" id="zip" type="text"
                   [(ngModel)]="newLocation.address.zip" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.zip.help'}]"></small>
        </div>
        <div class="form-group">
            <label class="control-label" for="country" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.country.label'}]"></label>
            <input class="form-control input-lg" name="country" id="country" type="text"
                   [(ngModel)]="newLocation.address.country" required>
            <small class="help-block m-b-none" [i18n]="[{target: 'innerHTML', key: 'local-loads.manual.form.modals.add-location.country.help'}]"></small>
        </div>
    </form>
</ng-template>
